import React, { useEffect } from "react";
import styled from "styled-components";
import { Box, Grid, LinearProgress, Paper } from "@mui/material";
import request from "src/utils/request";

const DbPaper = styled(Paper)`
    border-radius: 8px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const capitalize = (str) => {
    if (!str) return "";
    const parts = str.split("_");
    parts[0] = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
    return parts.join(" ");
};

const SetDatabaseItem = ({ databases, setupFields }) => {
    const [DbFullPaths, setDbFullPaths] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    if (!databases || (databases && !databases.length)) return null;

    useEffect(() => {
        const fetchDatabasePaths = async () => {
            setIsLoading(true);
            try {
                const responses = await Promise.all(
                    databases.map((database) =>
                        request(`/api/notion/database-full-path?id=${database.tasks.id}`, {
                            method: "GET",
                        })
                    )
                );
                const paths = {};
                databases.forEach((database, index) => {
                    paths[database.tasks.id] = responses[index].path;
                });
                setDbFullPaths(paths);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching the database full path:", error);
                setIsLoading(false);
            }
        };

        fetchDatabasePaths();
    }, [databases]);

    return databases.map((database) => (
        <Grid item key={database.tasks.id}>
            <DbPaper>
                <p
                    style={{
                        marginBottom: "6px",
                        marginTop: 0,
                    }}
                >
                    <strong>{database.tasks.name}</strong>
                </p>
                <p style={{ fontSize: "12px", opacity: "0.9", margin: 0 }}>
                    {DbFullPaths[database.tasks.id] ||
                        (isLoading ? (
                            <Box sx={{ width: "100%" }}>
                                <LinearProgress color="secondary" />
                            </Box>
                        ) : (
                            "Path not found"
                        ))}
                </p>
                <Box
                    style={{
                        backgroundColor: "#303030",
                        borderRadius: "8px",
                        padding: "8px",
                        marginTop: "8px",
                    }}
                >
                    {setupFields
                        .filter((item) => item.tableType === "tasks")
                        .map((field) => (
                            <p key={field.notionId} style={{ fontSize: "12px", margin: "4px" }}>
                                <strong>{capitalize(field.adadotName)}: </strong>
                                {field.notionName}
                            </p>
                        ))}
                </Box>
            </DbPaper>
        </Grid>
    ));
};

export default SetDatabaseItem;
